var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverIncentives(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 39,
    r: 24,
    fill: "#626262"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2912 31.0154C35.5414 24.0622 31.3674 30.7982 32.0527 34.5231C32.738 38.2481 37.2235 38.931 39.1236 39.2103C52.5489 41.1349 43.6091 56.9039 30.2772 47.0638",
    stroke: "#F2F2F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0022 24V27.6627",
    stroke: "#F2F2F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0022 50.168V55.0415",
    stroke: "#F2F2F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6187 60.9567C64.943 61.7563 64.2392 62.5349 63.5072 63.2924C52.7259 74.2318 36.1476 77.1073 22.2914 70.4413C8.43526 63.7753 0.38323 49.0504 2.2731 33.8335",
    stroke: "#626262",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3813 15.0431C11.057 14.2435 11.7609 13.465 12.4929 12.7074C23.2741 1.76801 39.8524 -1.10752 53.7086 5.55851C67.5648 12.2245 75.6168 26.9494 73.7269 42.1663",
    stroke: "#626262",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43872 16.9579V8.54102L17 16.9579H8.43872Z",
    fill: "#626262",
    stroke: "#626262",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68 58.5411L68 66.958L59.4387 58.5411L68 58.5411Z",
    fill: "#626262",
    stroke: "#626262",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverIncentives);
export default __webpack_public_path__ + "static/media/discover-incentives.8b695fcc8c260ac09e8bc4040e24eca2.svg";
export { ForwardRef as ReactComponent };